// Monospace text for identifiers (clause numbers, uids, hashes): 12 px, muted by default.
import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

const TONES = { muted: "text-muted-foreground", ink: "text-foreground", blue: "text-brand-blue" } as const;

export function Mono({
  children,
  tone = "muted",
  className,
}: {
  children: ReactNode;
  tone?: keyof typeof TONES;
  className?: string;
}) {
  return <span className={cn("font-mono text-xs", TONES[tone], className)}>{children}</span>;
}
